import { getOfferProduct, sendAnalytics } from 'shared/utils/analytics';

interface ITrackChatOpenParams {
  label?: string;
  offerId: number;
  position: number;
  ownerId?: number;
  houseId: number;
}

export const trackChatPopupOpen = ({ label, offerId, position, ownerId, houseId }: ITrackChatOpenParams) =>
  sendAnalytics({
    category: 'Message_popup',
    action: 'open',
    label,
    products: [getOfferProduct(offerId, position)],
    page: {
      extra: {
        owner_id: ownerId,
        houseId,
      },
    },
  });
